export default "__VITE_ASSET__a887351d__"